var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19 7h-2.184A2.99 2.99 0 0 0 14 5a2.99 2.99 0 0 0-2.816 2H5a1 1 0 0 0 0 2h6.184A2.99 2.99 0 0 0 14 11a2.99 2.99 0 0 0 2.816-2H19a1 1 0 0 0 0-2M19 15h-6.184A2.99 2.99 0 0 0 10 13a2.99 2.99 0 0 0-2.816 2H5a1 1 0 0 0 0 2h2.184A2.99 2.99 0 0 0 10 19a2.99 2.99 0 0 0 2.816-2H19a1 1 0 0 0 0-2"
})));
export default SvgFilter;